import type { CommandBarActionImpl } from './actions/types';
import type { ActionImpl } from 'kbar';

export function buildHeaderKinds(
  results: (string | ActionImpl)[]
): Map<string, string> {
  const kinds = new Map<string, string>();
  results.forEach((item, index) => {
    if (typeof item !== 'string') return;
    const next = results[index + 1];
    const kind =
      next && typeof next !== 'string'
        ? (next as CommandBarActionImpl).contextKind
        : undefined;
    if (kind) kinds.set(item, kind);
  });
  return kinds;
}
